(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-dsv-legal]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const body = root.querySelector('[data-legal-body]');
      const list = root.querySelector('[data-legal-toc]');
      const seen = new Set();
      body.querySelectorAll('h2,h3,h4,p,strong,b').forEach(el => {
        const title = el.textContent.trim();
        if (!/^Artikel\s+\d+\s*[–—-]/i.test(title) || title.length > 130) return;
        if ([...el.children].some(child => /^Artikel\s+\d+/i.test(child.textContent.trim()))) return;
        const number = title.match(/^Artikel\s+(\d+)/i)[1];
        if (seen.has(number)) return;
        seen.add(number);
        el.id = 'partner-artikel-' + number;
        el.classList.add('dp-article-heading');
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + el.id;
        a.textContent = title.replace(/^Artikel\s+\d+\s*[–—-]\s*/i, '');
        li.append(a); list.append(li);
      });
      if (list.children.length) root.querySelector('[data-legal-nav]').hidden = false;
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  window.addEventListener('pagehide', () => {
    const account = document.querySelector('[data-dsv-account]');
    if (account) account.style.visibility = 'hidden';
  });
  window.addEventListener('pageshow', e => {
    if (e.persisted && document.querySelector('[data-dsv-account]')) location.reload();
  });
})();
